(ns common.fields.table-column-widths
  (:require [common.schema.registry :as schema-registry]
            [common.schema.data-types :as data-types]))

(defonce min-width 50)
(defonce default-width 200)
(defonce max-width 1200)

(defn get-column-width [field-key]
  {:min-width min-width :default-width default-width :max-width max-width})
